import React, { useEffect, useState } from 'react';
import { Card, List, Typography } from 'antd';
import UserStore from 'stores/UserStore';
import EditInvoice from 'components/ContactActions/EditInvoice';
import Verify from '../../../components/Verify';

import UIStore from '@/stores/UIStore';

const { Paragraph, Title } = Typography;

const ManageInvoice: React.FC = () => {
    const [data, setData] = useState<any[]>([]);
    const invoicePreferencesReady = data.length > 0;

    const loadData = () => {
        if (UserStore?.user?.default_contact?.id) {
            UserStore.getContactInvoice(UserStore?.user?.default_contact?.id).then(data => {
                setData([data]);
            });
        }
    };

    useEffect(() => {
        UIStore.setSelectedKey(['contact']);
        UIStore.setDocumentTitle('Invoice');

        if (UserStore.isVerified) {
            loadData();
        }
    }, []);

    const updateData = () => {
        if (UserStore?.user?.default_contact?.id) {
            UserStore.getContactInvoice(UserStore?.user?.default_contact?.id).then(data => {
                setData([data]);
            });
        }
    };

    if (!UserStore.isVerified) {
        return <Verify />;
    }

    return (
        <section
            data-testid="page-customer-settings-invoice-preferences"
            data-ready={invoicePreferencesReady ? 'true' : 'false'}
        >
            <Paragraph>Change the contact information we use in order to send invoices</Paragraph>
            <Card
                title="Invoice email address"
                bordered
                data-testid="customer-settings-invoice-preferences-panel"
            >
                {!UserStore.isVerified && <Verify />}
                {data.length > 0 && (
                    <List
                        data-testid="customer-settings-invoice-preferences-list"
                        data-ready={invoicePreferencesReady ? 'true' : 'false'}
                        itemLayout="horizontal"
                        dataSource={data}
                        renderItem={(item, index) => {
                            const actions = [];
                            const invoiceEmail =
                                item?.invoice_email_address == null
                                    ? item?.email
                                    : item?.invoice_email_address;
                            const contact = (
                                <>
                                    <p className="text-base font-normal">
                                        {invoiceEmail}
                                    </p>
                                    <EditInvoice record={item} updateData={updateData} />
                                </>
                            );

                            return (
                                <List.Item
                                    key={index}
                                    data-testid="customer-settings-invoice-preferences-row"
                                    data-contact-id={item?.id}
                                    data-invoice-email={invoiceEmail}
                                >
                                    <List.Item.Meta description={contact} title="Email Address:" />
                                </List.Item>
                            );
                        }}
                    />
                )}
            </Card>
        </section>
    );
};

export default ManageInvoice;
